// src/app/router/index.jsx

import * as React from "react";
import { createBrowserRouter, Navigate } from "react-router-dom";

import AppLayout from "../layout/AppLayout";
import { ROUTES } from "../shared/constants/routes";

// Pages (existing)
import OverviewPage from "../features/overview/pages/OverviewPage";
import OrganizationProfilePage from "../features/organization/pages/OrganizationProfilePage";
import StaffDetailsPage from "../features/staff/pages/StaffDetailsPage";

import LiveMonitoringPage from "../features/monitoring/pages/LiveMonitoringPage";
import MonitoringSessionsPage from "../features/monitoring/pages/MonitoringSessionsPage";
import MonitoringAlarmsPage from "../features/monitoring/pages/MonitoringAlarmsPage";
import MonitoringHistoryPage from "../features/monitoring/pages/MonitoringHistoryPage";

import VitalsStreamingPage from "../features/vitals/pages/VitalsStreamingPage";
import VitalsRulesPage from "../features/vitals/pages/VitalsRulesPage";
import VitalsHistoryPage from "../features/vitals/pages/VitalsHistoryPage";

import FludeeBalancePage from "../features/balance/pages/FludeeBalancePage";
import IntakeOutputPage from "../features/balance/pages/IntakeOutputPage";

import MedicineChartSchedulePage from "../features/medicine/pages/MedicineChartSchedulePage";
import MedicineSchedulePage from "../features/medicine/pages/MedicineSchedulePage";

import SettingsPage from "../features/settings/pages/SettingsPage";

// ✅ Core module pages
import HospitalForm from "../core_modules/pages/HospitalForm";
import Profile from "../core_modules/pages/Profile";
import CoreSetupPage from "../core_modules/pages/CoreSetupPage";
import CoreWizardPage from "../core/pages/CoreWizardPage";
import CoreListPage from "../core/pages/CoreListPage";
import HospitalProfilePage from "../core/pages/HospitalProfilePage";

import PatientsCreatePage from "../paitents_detils/pages/PatientsCreatePage";
import PatientIdentifiersCreatePage from "../paitents_detils/pages/PatientIdentifiersCreatePage";
import AdmissionsCreatePage from "../paitents_detils/pages/AdmissionsCreatePage";
import AdmissionBedStaysCreatePage from "../paitents_detils/pages/AdmissionBedStaysCreatePage";
import PatientIntakePage from "../paitents_detils/pages/PatientIntakePage";
import PatientIntakeWizard from "../paitents_detils/components/PatientIntakeWizard";
import PatientListPage from "../paitents_detils/pages/PatientListPage";
import PatientProfilePage from "../paitents_detils/pages/PatientProfilePage";
import AdmissionBedStayForm from "../paitents_detils/components/AdmissionBedStayForm";
import DeviceCreatePage from "../devices/pages/DeviceCreatePage";
import SensorChannelCreatePage from "../devices/pages/SensorChannelCreatePage";
import DeviceAssignmentCreatePage from "../devices/pages/DeviceAssignmentCreatePage";
import TelemetryDashboardPage from "../Telemetry/pages/TelemetryDashboard";
import DripSessionsPage from "../monitoring/pages/DripSessionsPage";
import AuthPage from "../Auth/pages/AuthPage";
import AdmissionListSmart from "../paitents_detils/pages/AdmissionListSmart";
import AdmissionDetailPage from "../paitents_detils/pages/AdmissionDetailPage";
import DeviceAssignmentListPage from "../devices/pages/DeviceAssignmentListPage";
import DeviceAssignmentDetailsPage from "../devices/pages/DeviceAssignmentDetailsPage";
import DripSessionListPage from "../monitoring/pages/DripSessionListPage";
import LiveMonitoringPages from "../monitoring/pages/LiveMonitoringPage";
import DripSessionDetailsPage from "../monitoring/pages/DripSessionDetailsPage";
import LoginPage from "../Auth/pages/LoginPage";
import SignupPage from "../Auth/pages/SignupPage";
import PrivateRoute from "../Auth/components/PrivateRoute";
import PublicRoute from "../Auth/components/PublicRoute";

import AdminDashboardPage from "../admin/pages/AdminDashboardPage";
import DoctorDashboardPage from "../doctor/pages/DoctorDashboardPage";
import PatientDashboardPage from "../patient/pages/PatientDashboardPage";
import MedicineChartPage from "../medicinechart/pages/MedicineChartPage";
import FluidTherapyPatientSummaryPage from "../medicinechart/pages/FluidTherapyPatientSummaryPage";
import FluidTherapyPatientHistoryDetailsPage from "../medicinechart/pages/FluidTherapyPatientHistoryDetailsPage";
import MedicationChartForm from "../medicinechart/pages/MedicationChartForm";
import MedicationPatientSummaryPage from "../medicinechart/pages/MedicationPatientSummaryPage";
import MedicationPatientHistoryDetailsPage from "../medicinechart/pages/MedicationPatientHistoryDetailsPage";
import InvestigationForm from "../medicinechart/pages/InvestigationForm";
import InvestigationPatientSummaryPage from "../medicinechart/pages/InvestigationPatientSummaryPage";
import InvestigationPatientHistoryDetailsPage from "../medicinechart/pages/InvestigationPatientHistoryDetailsPage";
import PatientClinicalOverviewDashboard from "../medicinechart/pages/PatientClinicalOverviewDashboard";
import PatientClinicalSummaryPage from "../medicinechart/pages/PatientClinicalSummaryPage";
import PatientClinicalHistoryDetailsPage from "../medicinechart/pages/PatientClinicalHistoryDetailsPage";
import FludeeMonitor from "../services/components/Monitor";
import Dashboard from "../services/page/Dashboard";

//  import CreateUrineOutputSession from "../monitoring/pages/CreateUrineOutputSession";
// import CoreRoutes from "../core_modules/routes/CoreRoutes";

// Optional: nice error page (prevents ugly default 404)
function ErrorPage() {
  return (
    <div style={{ padding: 24 }}>
      <h2>404 - Page Not Found</h2>
      <p>Route not found. Please check URL.</p>
    </div>
  );
}

export const router = createBrowserRouter([
  {
    element: <AppLayout />,
    errorElement: <ErrorPage />,
    children: [
      //  Default open
      { path: ROUTES.OVERVIEW, element: <HospitalForm/> },

      // Organization + Staff
      { path: ROUTES.ORG_PROFILE, element: <OrganizationProfilePage /> },
      { path: ROUTES.STAFF_DETAILS, element: <StaffDetailsPage /> },

      // Monitoring
      { path: ROUTES.MONITORING_LIVE, element: <LiveMonitoringPage /> },
      { path: ROUTES.MONITORING_SESSIONS, element: <MonitoringSessionsPage /> },
      { path: ROUTES.MONITORING_ALARMS, element: <MonitoringAlarmsPage /> },
      { path: ROUTES.MONITORING_HISTORY, element: <MonitoringHistoryPage /> },
      { path: ROUTES.drip_sessions, element: <DripSessionsPage /> },

      // Vitals
      { path: ROUTES.VITALS_STREAMING, element: <VitalsStreamingPage /> },
      { path: ROUTES.VITALS_RULES, element: <VitalsRulesPage /> },
      { path: ROUTES.VITALS_HISTORY, element: <VitalsHistoryPage /> },

      // Balance
      { path: ROUTES.FLUDEE_BALANCE, element: <FludeeBalancePage /> },
      { path: ROUTES.INTAKE_OUTPUT, element: <IntakeOutputPage /> },

      // Medicine
      { path: ROUTES.MEDICINE_CHART, element: <MedicineChartSchedulePage /> },
      { path: ROUTES.MEDICINE_SCHEDULE, element: <MedicineSchedulePage /> },

      // Settings
      { path: ROUTES.SETTINGS, element: <SettingsPage /> },

    
       { path: ROUTES.CORE_HOSPITAL, element: <HospitalForm /> },
      

       // ================= CORE (NEW) =================
      // /core -> redirect to /core/setup
      // { path: ROUTES.CORE_ROOT, element: <Navigate to={ROUTES.CORE_SETUP} replace /> },

      // Wizard (forms only)
      { path: ROUTES.COREE_SETUP, element: <CoreWizardPage /> },

      // Lists (tables only)
      { path: ROUTES.COREE_LISTS, element: <CoreListPage /> },

      // Hospital profile drilldown
      { path: ROUTES.COREE_HOSPITAL_PROFILE(), element: <HospitalProfilePage /> },

  
      // ================= PATIENTS (NEW create pages) =================
      { path: ROUTES.PATIENTS_CREATE, element: <PatientsCreatePage/>  },
    
      { path: ROUTES.PATIENT_IDENTIFIERS_CREATE, element: <PatientIdentifiersCreatePage /> },
      { path: ROUTES.ADMISSIONS_CREATE, element: <AdmissionsCreatePage /> },
      { path: ROUTES.ADMISSION_BED_STAYS_CREATE, element:<AdmissionBedStayForm/> },
      { path: ROUTES.PATIENT_INTAKE, element: <PatientIntakeWizard /> },
      {path: ROUTES.ADMISSIONS_LIST,  element: <AdmissionListSmart />,},
      { path: ROUTES.ADMISSIONS_DETAILS_PATH, element: <AdmissionDetailPage />,},
          // ✅ Patient list page
      { path: ROUTES.PATIENTS_LIST, element: <PatientListPage /> },

      // ✅ Patient profile by UHID
      { path: ROUTES.PATIENT_PROFILE_PATH, element: <PatientProfilePage /> },

      /// fludee device 
       { path: ROUTES.DEVICE_CREATE, element: <DeviceCreatePage /> },

       { path: ROUTES.DEVICE_ASSIGNMENT_CREATE, element: <DeviceAssignmentCreatePage/> },

       { path: ROUTES.DEVICE_ASSIGNMENT_LIST,element: <DeviceAssignmentListPage />,},
       { path: ROUTES.DEVICE_ASSIGNMENT_DETAILS_PATH,element: <DeviceAssignmentDetailsPage />,},

       { path: ROUTES.SENSOR_CHANNELS_CREATE, element: <SensorChannelCreatePage /> },
       //================================================================
       { path: ROUTES.Telemetry_live, element: <TelemetryDashboardPage/> },

//------------------------------------------------------------------------------------------
        { path: ROUTES.Dripsession_list, element: <DripSessionListPage/> },
      { path: ROUTES.Dripsession_Details_pages, element: <DripSessionDetailsPage/> },
       { path: ROUTES.Livemonitoringpages, element: <LiveMonitoringPages/> },
      //  { path: ROUTES.Graph_live_list, element: <DeviceAssignmentListPagee/> },
         { path: ROUTES.FluidTherapy, element: <MedicineChartPage /> },

      {
    path: ROUTES.AUTH_LOGIN,
    element: <LoginPage />,
  },
  {
    path: ROUTES.AUTH_SIGNUP,
    element: <SignupPage/>,
  },

  {
  path: ROUTES.AUTH_LOGIN,
  element: (
    <PublicRoute>
      <LoginPage />
    </PublicRoute>
  ),
},
{
  path: ROUTES.AUTH_SIGNUP,
  element: (
    <PublicRoute>
      <SignupPage />
    </PublicRoute>
  ),
},
{
  path: ROUTES.ADMIN_DASHBOARD,
  element: (
    <PrivateRoute allowedRoles={["ADMIN"]}>
      <AdminDashboardPage />
    </PrivateRoute>
  ),
},
{
  path: ROUTES.DOCTOR_DASHBOARD,
  element: (
    <PrivateRoute allowedRoles={["DOCTOR"]}>
      <DoctorDashboardPage />
    </PrivateRoute>
  ),
},
{
  path: ROUTES.PATIENT_DASHBOARD,
  element: (
    <PrivateRoute allowedRoles={["PATIENT"]}>
      <PatientDashboardPage />
    </PrivateRoute>
  ),
},
        // { path: ROUTES.Urine_output, element: <CreateUrineOutputSession/> },


        {
  path: ROUTES.fluid_therapy_history,
  element: <FluidTherapyPatientSummaryPage />,
},
{
  path: ROUTES.fluid_therapy_history_details_path,
  element: <FluidTherapyPatientHistoryDetailsPage />,
},


{ path: ROUTES.MEDICATION_CHART, element: <MedicationChartForm /> },


{
  path: ROUTES.MEDICATION_SUMMARY,
  element: <MedicationPatientSummaryPage />,
},
{
  path: ROUTES.medication_history_details(),
  element: <MedicationPatientHistoryDetailsPage />,
},

{
  path: ROUTES.INVESTIGATION_CREATE,
  element: <InvestigationForm />,
},

{
  path: ROUTES.INVESTIGATION_HISTORY,
  element: <InvestigationPatientSummaryPage />,
},
{
  path: ROUTES.investigation_history_details(":patientUhid"),
  element: <InvestigationPatientHistoryDetailsPage />,
},
{
  path: ROUTES.PatientClinicalOverviewDashboard,
  element: <PatientClinicalSummaryPage />,
},
{
  path: ROUTES.clinical_overview_details(),
  element: <PatientClinicalHistoryDetailsPage />,
},

{
  path: ROUTES.Fludee_Front_Live,
  element: <Dashboard/>
},
      //  Fallback any unknown route → overview
      { path: "*", element: <Navigate to={ROUTES.OVERVIEW} replace /> },
    ],
  },
]);